import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import Colors from '../../../../styles/colors';
import Toggle from 'react-toggle';
import { STATIC_HOMEPAGE_URL } from '../../../../config';

const Status = (props) => {
  const {
    episodeId,
    viewLinks,
    public: isPublic,
    onStatusChange,
  } = props;
  // console.log('Status public', isPublic);
  let mainStatusText = isPublic ? 'This track is public' : 'This track is private';
  let miniSubheaderText = isPublic
      ? 'anybody can access'
      : 'only accessible to subscribed audience';
  let sharelink = (viewLinks && isPublic && !isEmpty(episodeId))
    ? (
      <span style={styles.miniSubheaderText}>
        <a
          target="_blank"
          href={`${STATIC_HOMEPAGE_URL}/episodes/${episodeId}`}
          style={{ ...styles.statusLink, color: Colors.mainOrange }}
        >
          Share Link
        </a>
      </span>
    )
    : null;

  return (
    <div className="row" style={styles.rowDivision}>
      <div id="status" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <div style={styles.toggleStatus}>
          <Toggle
            className="toggle-green"
            id="landing-status"
            aria-labelledby="status-label"
            checked={isPublic}
            onChange={onStatusChange}
          />
          <span id="status-label" style={styles.toggleStatusLabel}>
            {mainStatusText} <span style={styles.miniSubheaderText}>({miniSubheaderText})</span> {sharelink}
          </span>
        </div>
      </div>
    </div>
  );
};

Status.propTypes = {
  episodeId: PropTypes.string,
  public: PropTypes.bool,
  viewLinks: PropTypes.bool,
  onStatusChange: PropTypes.func
};


Status.defaultProps = {
  episodeId: '',
  public: false,
  viewLinks: false,
  onStatusChange: () => {}
};

export default Status;
